module.exports = __webpack_public_path__ + "media/images/registration_set_up-2bf76c3c.svg";